/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechPhoneSmartOffIcon20Solid = forwardRef('TechPhoneSmartOffIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.296 1.704A1.125 1.125 0 0 0 .705 3.296l16 16a1.125 1.125 0 0 0 1.59-1.591l-2.32-2.32c.017-.126.025-.255.025-.385V5a3 3 0 0 0-3-3H7a3 3 0 0 0-2.706 1.703L2.296 1.705Zm4.06 4.061-.121-.121a1 1 0 1 1 .122.122Z" }),
        React.createElement("path", { d: "M4 15V9.121l5.004 5.004H7a.875.875 0 0 0 0 1.75h3.754L12.879 18H7a3 3 0 0 1-3-3Z" })));
});
